<template>
     <b-card class="executive-team-card">
        <template v-slot:header>
            <div class="picture">
                <b-avatar :src="people.picture" size="115px" variant="secondary"></b-avatar>
            </div>
            <div class="title">
                <h3>{{ people.name }}</h3>
                <h4>{{ people.title }}</h4>
            </div>
        </template>
        <b-card-body>
            <b-card-text>{{ people.description }}</b-card-text>
            <div class="social-media-links">
                <a :href="people.facebook" v-if="people.facebook" target="_blank">
                    <i class="icons8-facebook-f"></i>
                </a>
                <a :href="people.linkedinUrl" v-if="people.linkedinUrl" target="_blank">
                    <i class="icons8-linkedin-2"></i>
                </a>
                <a :href="`https://twitter.com/${people.twitterAccountId}`" v-if="people.twitterAccountId" target="_blank">
                    <i class="icons8-twitter"></i>
                </a>
                <a :href="'mailto:' + people.email" v-if="people.email">
                    <i class="icons8-new-post"></i>
                </a>
            </div>
        </b-card-body>
    </b-card>
</template>
<script>
export default {
    name: 'executive-team-card',

    props: {
        people: {
            type: Object,
            default() {
                return {};
            },
        },
    },
};
</script>
<style lang="scss" scoped>
.executive-team-card {
    &.card {
        background-color: #0B0124;
    }
    .card-body,
    .card-header {
        padding: 0;
    }
    .card-header {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .title {
            margin-left: 25px;
            width: 75%;
        }
        h3 {
            font-size: 20px;
            font-weight: 700;
            margin-bottom: 10px;
        }

        h4 {
            font-size: 15px;
            color: #B5C0C7;
        }
    }
    p {
        line-height: 30px;
        font-size: 16px;
        font-weight: 500;
    }
    i {
        font-size: 20px;
        color: #FFFFFF;
        opacity: 0.6;

        &:hover {
            opacity: 1;
        }
    }
    .social-media-links a {
        margin-right: 15px;
    }
}
</style>
